// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"HeaderSection_dropdown__2CvRy"};